const BIDS_KEY = 'online_bids';
const ACTIVE_BID_KEY = 'online_bid_active';
const SALON_KEY = 'salon_id';

export function getBidsFromLocalStorage() {
    const bids = JSON.parse(sessionStorage.getItem(BIDS_KEY));
    const activeBid = parseInt(sessionStorage.getItem(ACTIVE_BID_KEY));
    if (bids !== null && !isNaN(activeBid)) {
        this.$store.commit('SET_BIDS', bids);
        this.$store.commit('SELECT_BID_INDEX', activeBid);
    }
}

export function setBidsInLocalStorage(arr = [], activeBid) {
    const bids = JSON.stringify(arr);
    sessionStorage.setItem(BIDS_KEY, bids);
    sessionStorage.setItem(ACTIVE_BID_KEY, String(activeBid));
    sessionStorage.setItem('auth_type', 'registration_client');
}

export function clearBidsInLocalStorage() {
    sessionStorage.removeItem(BIDS_KEY);
    sessionStorage.removeItem(ACTIVE_BID_KEY);
    sessionStorage.setItem('auth_type', 'registration_client');
}

export function getSalonIdFromLocalStorage() {
    return JSON.parse(sessionStorage.getItem(SALON_KEY));
}

export function setSalonIdInLocalStorage(salonId) {
    const bids = JSON.stringify(salonId);
    sessionStorage.setItem(SALON_KEY, bids);
}

export default {
    getBidsFromLocalStorage,
    setBidsInLocalStorage,
    clearBidsInLocalStorage,
    getSalonIdFromLocalStorage,
    setSalonIdInLocalStorage,
};
